import {Component, inject} from '@angular/core';
import {FileUploadComponent} from "../../../../shared/commons/app-file-upload/file-upload/file-upload.component";
import {FormsModule} from "@angular/forms";
import {
  ArbitraryType,
  ResultArbitraryReportDto,
  SrmHospitalArbitraryReportDto
} from "../../../../../generated-model/model";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {NgClass} from "@angular/common";
import {SrmHospitalArbitraryResource} from "../../../../service/SrmHospitalArbitraryResource";
import {ToastService} from "../../../../shared/commons/toast/toast-service";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-arbitrary-report',
  standalone: true,
  imports: [
    FileUploadComponent,
    FormsModule,
    SharedCommonModule,
    NgClass
  ],
  templateUrl: './arbitrary-report.component.html',
  styleUrl: './arbitrary-report.component.scss'
})
export class ArbitraryReportComponent {
  request: SrmHospitalArbitraryReportDto = {}
  result: ResultArbitraryReportDto
  srmHospitalArbitraryResource = inject(SrmHospitalArbitraryResource)
  confirmDialogService = inject(ConfirmDialogService)
  private _toastrService: ToastService = inject(ToastService);

  prepareArbitrary($event: any) {
    this.srmHospitalArbitraryResource.prepareReport(this.request)
      .subscribe(value => {
        this.result = value
        this.request.srmHospitalArbitraryId = value.srmHospitalArbitraryId
        this.request.auditDetected = value.detected
      });
  }

  ARBITRARY_TYPE(value: string) {
    return ArbitraryType[value]
  }

  reset() {
    this.request = {}
    this.result = undefined
  }

  submit() {
    const modalRef = this.confirmDialogService.open({
      content: 'ยืนยันการบันทึก',
    })
      .pipe(filter(e => !!e))
      .subscribe(e => {
        this.srmHospitalArbitraryResource.saveArbitraryReport(this.request)
          .subscribe(value => {
            this._toastrService.showSuccess("บันทึกเสร็จสมบูรณ์");
            this.reset();
          });
      });
  }
}
